module.exports = __webpack_public_path__ + "img/story4.32130539.png";